import { createSelector } from 'reselect'

/**
 * Checks whether the parsing is completed.
 * @returns {boolean}
 */
function isParsingCompletedSelector () {
  return createSelector(
    state => state && state.parser,
    parser => !parser.data.length
  )
}

export {
  isParsingCompletedSelector
}
